AgrimarketControllers.controller('dynamicFormsController', ['$rootScope', '$location',
    function ($rootScope, $location) {
        if (!$rootScope.ModuleDynamicForms.Active)
            $location.path('/');
    }
]);